import React from 'react';
import { useTranslation } from 'react-i18next';
import Card from './Card';
import './CapabilitiesTable.css';

/* Capacités — second axe des droits, en LECTURE SEULE.
   Un périmètre dit quelle DONNÉE on voit (lecture/écriture) ; une capacité dit
   quelle ACTION sur le système on peut déclencher. Les deux ne se mélangent pas :
   « lecture seule sur la suppression » n'a pas de sens.
   Source unique : `CAPABILITIES` dans backend/app/core/entitlements.py, servi par
   GET /api/auth/roles. Rien n'est éditable ici — ces règles sont dans le code,
   pas en base, précisément parce qu'elles gardent des actions irréversibles.
   Partagé par Administration › Rôles et Paramètres › Utilisateur. */

export default function CapabilitiesTable({ capabilities = [], roles = [], mine = null }) {
  const { t } = useTranslation();
  if (!capabilities.length) return null;

  const mineSet = mine ? new Set(mine) : null;

  return (
    <Card
      title={t('admin:capabilities.title')}
      subtitle={t('admin:capabilities.subtitle')}
      flush
    >
      <table className="cap-table">
        <thead>
          <tr>
            <th>{t('admin:capabilities.actionColumn')}</th>
            {roles.map((r) => (
              <th key={r.id} className={mineSet?.has(r.slug) ? 'cap-mine' : undefined}>
                {r.name}
              </th>
            ))}
            <th className="cap-operator">{t('admin:capabilities.operator')}</th>
          </tr>
        </thead>
        <tbody>
          {capabilities.map((c) => (
            <tr key={c.id}>
              <td className="cap-label">
                <span className="cap-label__name">{t(`admin:capabilities.items.${c.id}`)}</span>
              </td>
              {roles.map((r) => {
                const ok = !c.platform_only && (c.roles || []).includes(r.slug);
                return (
                  <td key={r.id} className={`cap-cell${mineSet?.has(r.slug) ? ' cap-mine' : ''}`}>
                    {ok ? <span className="cap-yes" aria-label={t('admin:capabilities.granted')}>✓</span>
                        : <span className="cap-no" aria-hidden>—</span>}
                  </td>
                );
              })}
              <td className="cap-cell cap-operator">
                {c.platform_only
                  ? <span className="cap-yes" aria-label={t('admin:capabilities.granted')}>✓</span>
                  : <span className="cap-yes" aria-label={t('admin:capabilities.granted')}>✓</span>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Card>
  );
}
